import React from 'react';
import { SortDirection, GlobalFilterType } from 'utils/types';
import { VOIDS_ITEMS_DETAILS_SERIES } from 'apollo/queries';
import Formats from 'utils/formats';
import { getColor } from 'containers/Voids';
import moment from 'moment';
import OpportunityMatrixWidget from 'components/OpportunityMatrixWidget/index';
import './styles.scss';

interface Props {
  clientId: string;
  globalFilter: GlobalFilterType;
}

const ItemsOpportunityMatrixWidget: React.FC<Props> = ({ clientId, globalFilter }) => {
  const matrixTableDataResolver = (data, currentSortBy, currentSortDirection, sortHandler) => {
    return {
      headers: {
        fixed: [
          {
            header: 'Item',
            sortable: {
              current: currentSortBy === 'description',
              direction: currentSortDirection,
              onSort: () => sortHandler('description')
            }
          },
          {
            header: 'UPC',
            sortable: {
              current: currentSortBy === 'upc',
              direction: currentSortDirection,
              onSort: () => sortHandler('upc')
            }
          }
        ],
        variable: [{ value: 'Date Last Scanned', tooltip: undefined }]
      },
      rows: data.voidItemsDetailsSeries.data.map(row => {
        return {
          fixed: [
            {
              value: row.description
            },
            {
              value: row.upc,
              tooltip: (
                <React.Fragment>
                  <div>{`Dollars: ${Formats.currency(row.sales)}`}</div>
                </React.Fragment>
              )
            }
          ],
          id: row.upc,
          variable: [
            {
              value:
                row.recentSaleDate !== null
                  ? moment.parseZone(row.recentSaleDate).format('MM/DD/YY')
                  : '-',
              color: getColor(row.distributionState),
              tooltip: undefined
            }
          ]
        };
      })
    };
  };

  const dataTotalResolver = data => data.voidItemsDetailsSeries.page.totalItems;
  const dataResolver = data => data.voidItemsDetailsSeries.data;

  return (
    <div className="items-opportunity-matrix-widget">
      <OpportunityMatrixWidget
        clientId={clientId}
        dataTotalResolver={dataTotalResolver}
        defaultSortBy="sales"
        defaultSortDirection={SortDirection.DESC}
        globalFilter={globalFilter}
        matrixTableDataResolver={matrixTableDataResolver}
        query={VOIDS_ITEMS_DETAILS_SERIES}
        title="Items"
        dataResolver={dataResolver}
      />
    </div>
  );
};

export default ItemsOpportunityMatrixWidget;
